import * as actionTypes from './actionTypes';
import { JobModel } from '@app/src/views/StepOne/form/models/job';

interface State {
  data: JobModel[];
  isFetching: boolean;
  error: boolean;
}

const initialState: State = {
  data: [],
  isFetching: false,
  error: false
}

export const jobTop = (state = initialState, action): State => {
  switch (action.type) {
    case actionTypes.FETCH_JOB_TOP_REQUEST:
      return {
        ...state,
        isFetching: true
      }
    case actionTypes.FETCH_JOB_TOP_FAILURE:
      return {
        ...state,
        isFetching: false,
        error: true
      }
    case actionTypes.FETCH_JOB_TOP_SUCCESS:
      return {
        ...state,
        isFetching: false,
        error: false,
        data: action.data
      }
    default:
      return state;
  }
}
